var _title, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgUscConnected = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 49 28",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "556B2AA6-40B2-4235-9573-F5F6E49391F3")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop-Events",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-Event-Groups",
    transform: "translate(-1097.000000, -286.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BTN-/-28-/-USC-/-Connected",
    transform: "translate(1097.000000, 286.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(8.000000, 5.000000)",
    fill: "#383E41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7996891,3.59989484 L12.5996358,3.59989484 L12.5996358,0 L8.99974245,0 L8.99974245,1.79994742 L10.7996891,1.79994742 L10.7996891,1.79994742 L10.7996891,3.59989484 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5996312,11.6996574 L12.5996312,5.39984168 L10.7996839,5.39984168 L10.7996839,11.6996574 C10.7996839,14.184866 8.78502432,16.1995258 6.29981558,16.1995258 C3.81460685,16.1995258 1.79994731,14.184866 1.79994731,11.6996574 L1.79994731,1.79994723 L7.19978924,1.79994723 L7.19978924,0 L0,0 L0,11.6996574 C0,15.1792403 2.8207598,18 6.30034292,18 C9.77992605,18 12.6006858,15.1792403 12.6006858,11.6996574",
    id: "Path"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M48,0.5 L48.5,27 L1,27.5 L0.5,1 L48,0.5 Z",
    id: "Rectangle",
    stroke: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-1",
    stroke: "#07AB00",
    strokeWidth: 2,
    points: "29 12.9179267 34.6601807 19.0076442 41 8"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUscConnected, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/USCConnected.0e43a42b.svg";
export { ForwardRef as ReactComponent };